var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.showLoading),callback:function ($$v) {_vm.showLoading=$$v},expression:"showLoading"}},[_c('v-card',{staticClass:"pt-4"},[_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t("loading.PLEASE_WAIT"))+" "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }